// @flow
import { KEY } from './constants'

export const getBeneficiary = (state: Object) => state[KEY]
